import { Link } from "react-router-dom";
import "./result.css";
import questions from "../../assets/questions/questions.dr.json";

function isCorrect(correctAnswer, userAnswer) {
  if (correctAnswer == null || userAnswer == null) return false;
  const answer = Object.values(userAnswer).filter((x) => x !== null);
  if (answer.length !== correctAnswer.length) return false;

  return answer.every((elt) => {
    if (elt !== null) {
      return correctAnswer.includes(elt);
    }
    return true;
  });
}

const Answer = ({ correctAnswer, userAnswer, onClick, index }) => {
  const isCorrectAnswer = isCorrect(correctAnswer, userAnswer);

  return (
    <div
      style={{ backgroundColor: isCorrectAnswer ? "green" : "hsl(5 75% 50% / 1)" }}
      className="result-item"
      onClick={onClick}
    >
      <h1>{index + 1}</h1>
    </div>
  );
};

const Score = ({ userAnswers, correctAnswers }) => {
  const score = correctAnswers.reduce((acc, correctAnswer, index) => {
    const isCorrectAnswer = isCorrect(correctAnswer, userAnswers?.[index]);
    if (isCorrectAnswer) return ++acc;
    return acc;
  }, 0);
  // Define if the score is good, meh or bad according to its value
  const scoreClass =
    score < 32
      ? { class: "bad", color: "#e74c3c" }
      : score < 36
      ? { class: "meh", color: "#f1c40f" }
      : { class: "good", color: "#27ae60" };

  // // Define the background gradient according to the score and color
  const gradient = {
    background: `conic-gradient(${scoreClass.color}
      ${score * (100 / 40)}%, transparent 0 100%)`,
  };

  // Set the gradient as the rating background
  // rating.setAttribute("style", gradient);

  // Wrap the content in a tag to show it above the pseudo element that masks the bar
  return (
    <div className={`rating ${scoreClass.class}`} style={gradient}>
      <span>{score}</span>
    </div>
  );
};

function Result({
  history,
  match: {
    params: { serieNbr },
  },
}) {
  let userAnswers = JSON.parse(sessionStorage.getItem("__users_answers__"));
  const correctAnswers=Object.values(questions[`serie${serieNbr}`]).reduce((acc, qst)=>{
    const correctAnswer = [qst.ra.c,qst.rb.c,qst.rc.c,qst.rd.c].reduce((acc,elt,i)=>{
        if(elt!=="0") acc.push(i + 1);
        return acc
    },[])

    return [...acc, correctAnswer]
  },[])

  return (
    <>
      <div className="top-menu">
        <Link to="/">
          <img src="assets/home.svg" style={{ height: "2.5rem" }} alt="home" />
        </Link>
        <span style={{ flex: "auto" }}></span>
        <Score userAnswers={userAnswers} correctAnswers={correctAnswers}/>
      </div>
      {/* <span id="score">
        {score > 9 ? score : "0" + score}
        <span />
        40
      </span> */}
      <br />
      <div id="result-list">
        {correctAnswers.map((correctAnswer, index) => (
          <Answer
            key={Math.random()}
            {...{ correctAnswer, userAnswer: userAnswers?.[index], index }}
            onClick={() =>
              history.push(
                `/serie/${serieNbr}/question/${
                  index + 1
                }?correctAnswer=${correctAnswer}`
              )
            }
          />
        ))}
      </div>
    </>
  );
}

export default Result;
